module.exports = __webpack_public_path__ + "bd758e841bd6542933a5af597d5fbe12.jpg";